import { styled } from "styled-components";
const SPACE_VALUES = {
  none: 0,
  xsmall: 4,
  small: 8,
  medium: 16,
  large: 24,
  xlarge: 32
};
const StackWrapper = styled("div")(
  {
    display: "flex",
    flexDirection: "column",
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  ({ $alignX }) => ({
    center: {
      alignItems: "center"
    },
    left: {
      alignItems: "flex-start"
    },
    right: {
      alignItems: "flex-end"
    },
    stretch: {
      alignItems: "stretch"
    }
  })[$alignX],
  ({ $space }) => ({
    gap: SPACE_VALUES[$space]
  })
);
const StackItem = styled("div")({
  margin: 0,
  padding: 0
});
export {
  StackItem,
  StackWrapper
};
